import { createSlice } from "@reduxjs/toolkit";
import {
  getSellerTermsRequests,
  updateSellerTermsRequests,
} from "../../../thunks/seller-thunks/SellerThunk";
import { message } from "antd";

const initialState = {
  requestsTerms: [],
  requestsTermsUpdation: null,
  isTermsLoading: false,
  isTermsUpdationLoading: false,
};

export const termsRequestSlice = createSlice({
  name: "sellerterms",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(getSellerTermsRequests.pending, (state) => {
        state.isTermsLoading = true;
        state.requestsTerms = [];
      })

      .addCase(getSellerTermsRequests.fulfilled, (state, action) => {
        state.isTermsLoading = false;
        state.requestsTerms = action.payload;
      })
      .addCase(getSellerTermsRequests.rejected, (state, action) => {
        state.isTermsLoading = false;
        state.requestsTerms = action.payload.message;
        message.error("Some thing went wrong!");
      });
    builder
      .addCase(updateSellerTermsRequests.pending, (state) => {
        state.isTermsUpdationLoading = true;
        state.requestsTerms = [];
      })
      .addCase(updateSellerTermsRequests.fulfilled, (state, action) => {
        state.isTermsUpdationLoading = false;
        state.requestsTermsUpdation = action.payload;
        message.success(action.payload.message);
      })
      .addCase(updateSellerTermsRequests.rejected, (state, action) => {
        state.isTermsUpdationLoading = false;
        state.requestsTerms = action.payload.message;
        message.error("Some thing went wrong!");
      });
  },
});

export default termsRequestSlice.reducer;
